<template>
  <section id="prizes_carousel">
    <h1 v-if="showTitle"> {{ getTranslations.home_carousel_title}} </h1>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(prize, index) in slides" :key="`${prize.type}_${index}`">
          <div class="carousel-item">
            <img :src="prize.imgUrl">
            <h3 v-if="getPrizeText(prize.type)">{{ getPrizeText(prize.type) }}</h3>
            <p>{{ prize.headline }}</p>
          </div>
        </div>
      </div>

      <template v-if="showNavigation">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </template>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import translationMixin from "../../common/mixins/translation";
import {prizesEnum, prizesTranslationMap} from "../../constants/prizes";
import { padCarouselItems } from "../../helpers/carousel";

export default {
  name: 'carousel',
  props: {
    //Control Carousel's Title
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    translationMixin
  ],
  data() {
    return {
      swiperCarousel: null,
      slides: [
        {
          imgUrl: '',
          type: 'GRAND',
          headline: 'Grand'
        },
        {
          imgUrl: '',
          type: 'MONTHLY',
          headline: 'Monthly'
        },
        {
          imgUrl: '',
          type: 'DAILY',
          headline: 'Daily'
        }],
    };
  },
  methods: {
    getPrizeText(value) {
      return this.$_getTranslations[prizesTranslationMap[value]]
    }
  },
  created() {
    this.slides = padCarouselItems(this.getCarouselPrizes);
  },
  mounted() {
    if (this.swiperCarousel) {
      this.swiperCarousel = null;
    }
    this.$nextTick(() => {
      // slides may contain duplicate items in some cases (check comment in created() method)
      const originalCarouselSlideSize = this.getCarouselPrizes.length;
      /*eslint-disable */
      this.swiperCarousel = new Swiper('.swiper-container', {
        slidesPerView: originalCarouselSlideSize >= 2 ? 1.8 : 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          510: {
            slidesPerView: (() => {
              if (originalCarouselSlideSize === 2) {
                return 2
              } else if (originalCarouselSlideSize >= 3) {
                return 3
              }

              return 'auto'
            })(),
            centeredSlides: true,
            allowTouchMove: true,
            spaceBetween: 10,
            loop: this.slides.length > 1,
          }
        },
        on: {
          init: function () {
            this.slideToLoop(0, 0, true);
          }
        },
      });
    });
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getCarouselPrizes',
    ]),
    showNavigation() {
      return this.getCarouselPrizes.length > 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Carousel.vue